import ComponentElement from 'components/component-element';
import SelectionsSlider from 'components/selections-slider';

function UnverifiedPlate($element, options = {}) {
    ComponentElement.call(this, $element, options);

    const $support = this.$element.querySelector('.Support');
    if ($support) {
        $support.style.removeProperty('background');
    }

    this.$element.querySelectorAll('.js-selections-slider').forEach($element => new SelectionsSlider($element, {
        swiper: {
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        },
    }));
}

UnverifiedPlate.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(UnverifiedPlate.prototype, 'constructor', {
    value: ComponentElement,
    writable: true,
    enumerable: false,
});

export default UnverifiedPlate;
